/**
 * Lightweight haptic feedback via the Vibration API.
 * No-op on devices/browsers that don't support it.
 */

export function hapticTap() {
  if (navigator.vibrate) navigator.vibrate(4);
}

export function hapticSuccess() {
  if (navigator.vibrate) navigator.vibrate([4, 40, 6]);
}

export function hapticError() {
  if (navigator.vibrate) navigator.vibrate([15, 50, 15]);
}

/**
 * Attach haptic feedback to all interactive elements.
 * Call once on app mount. Uses event delegation on document.
 */
export function initHaptics() {
  if (!navigator.vibrate) return;

  document.addEventListener('pointerdown', (e) => {
    const el = e.target.closest('button, a, [role="button"], .primary-button, .secondary-button, .ghost-button, .v2-cta-primary, .v2-cta-secondary, .review-step, .chip-button, input[type="checkbox"], input[type="radio"]');
    if (el) hapticTap();
  }, { passive: true });
}
